import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React from 'react';
import * as ErrorStrategy from 'components/VisualizationStrategies/Error/ErrorStrategy';
import isEqual from 'lodash/isEqual';
import {renderCardById} from 'state/card/cardService';
import {cancelRequest} from 'utilities/Request';
import {selectIsDavinci} from 'state/environment/environmentSelectors';

const CardRender = (WrappedComponent, optionsFn) => {
  class CardRenderWrapper extends React.PureComponent {
    constructor() {
      super(...arguments);
      this.state = {};
    }

    UNSAFE_componentWillMount() {
      this.fetch(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      const options = (optionsFn && optionsFn(this.props)) || {};
      const nextOptions = (optionsFn && optionsFn(nextProps)) || {};

      if (
        this.props.cardId !== nextProps.cardId ||
        this.props.card !== nextProps.card ||
        !isEqual(options, nextOptions)
      ) {
        this.fetch(nextProps);
      }
    }

    componentWillUnmount() {
      this.cancelFetch();
    }

    cancelFetch() {
      cancelRequest(this.request);
    }

    fetch(props) {
      const renderOptions = (optionsFn && optionsFn(props)) || {};

      this.setState({
        cardRender: null,
        hasError: false,
      });

      this.request = renderCardById(props.cardId, renderOptions);
      this.request.then(
        (response) => {
          this.setState({cardRender: response});
        },
        (e) => {
          if (props.isDavinci)
            console.error(
              'Error: ' + e.statusText + ' ' + e.status + ' ' + e.message
            ); //to be picked up by puppeteer and fail image
          if (e.statusText === 'abort') return;
          this.setState({
            hasError: true,
          });
        }
      );
    }

    render() {
      const Error = ErrorStrategy[this.props.size];
      const content = this.state.hasError ? (
        <Error {...this.props} />
      ) : (
        <WrappedComponent cardRender={this.state.cardRender} {...this.props} />
      );
      return content;
    }
  }

  CardRenderWrapper.propTypes = {
    cardId: PropTypes.string.isRequired,
    size: PropTypes.oneOf(Object.keys(ErrorStrategy)).isRequired,
  };

  return connect(
    (state) => ({
      isDavinci: selectIsDavinci(state),
    }),
    {}
  )(CardRenderWrapper);
};

export default CardRender;
